import PubSub from "underpub-js";

var ContentButtonRight = function(options) {

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

ContentButtonRight.prototype.init = function() {

	var self = this;

	// left side text
	this.positionLeftSideText();

	PubSub.subscribe("resized", function(){
		self.positionLeftSideText();
	});

};

ContentButtonRight.prototype.positionLeftSideText = function() {

	// top
	var $leftSideText = this.options.$el.find('.left-side-text');
	var $contentWrapper = this.options.$el;

	var leftSideTextHeight = $leftSideText.width(); // element is rotated via css so width is actually height
	var leftSideTextWidth = $leftSideText.height(); // element is rotated via css so height is actually width
	var contentWrapperHeight = $contentWrapper.outerHeight();
	var contentWrapperWidth = $contentWrapper.width();

	var newTop = (contentWrapperHeight / 2) - (leftSideTextWidth / 2);
	$leftSideText.css('top', newTop);

	// left
	// the first two numbers here get the transformed element back to aligned with the edge, third number is the offset from the edge
	var newLeft = ((leftSideTextHeight / 2) * -1) + (leftSideTextWidth / 2) - (leftSideTextWidth / 2);
	$leftSideText.css('left', newLeft);

};

export default ContentButtonRight;
